// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-demo[data-v-0ee0b398] {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n}\n.icon-demo[data-v-0ee0b398] {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  font-size: 100px;\n  color: #409EFF;\n}\n.icon-demo[data-v-0ee0b398]:hover {\n  color: #F56C6C;\n  -webkit-transform: scale(1.2) rotate(30deg);\n          transform: scale(1.2) rotate(30deg);\n}", ""]);
// Exports
module.exports = exports;
